import { MarketView } from "@/components/market/market-view"

export default function SellerMarketPage() {
  return <MarketView />
}
